import React from 'react'
import classNames from 'classnames'
import { Badge, Card, CardBody, Media } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faCertificate, faImage, faTruck } from '@fortawesome/free-solid-svg-icons'
import Avatar from '../common/Avatar'
import {
  categoryIcon,
  formatAvailability,
  formatPriceRange,
  formatVisitFee,
  pricingModeShort
} from './marketplaceConstants'

const ServicePreviewCard = ({ service, coverUrl, provider, className }) => (
  <Card className={classNames('overflow-hidden', className)}>
    <div className="bg-200" style={{ height: 180 }}>
      {coverUrl ? (
        <img src={coverUrl} alt="" className="w-100 h-100" style={{ objectFit: 'cover' }} />
      ) : (
        <div className="h-100 d-flex align-items-center justify-content-center text-400">
          <FontAwesomeIcon icon={faImage} size="2x" />
        </div>
      )}
    </div>
    <CardBody>
      {service.category && (
        <Badge color="soft-primary" pill className="mb-2">
          <FontAwesomeIcon icon={categoryIcon(service.category)} className="mr-1" />
          {service.category.name}
        </Badge>
      )}
      <h5 className="fs-0 mb-2">{service.title || 'Título del servicio'}</h5>
      <p className="mb-1">
        <span className="font-weight-bold text-900">{formatPriceRange(service.price_min, service.price_max)}</span>
        <span className="fs--1 text-600 ml-1">{pricingModeShort(service.pricing_mode)}</span>
      </p>
      <p className="fs--1 text-700 mb-1">
        <FontAwesomeIcon icon={faTruck} className="text-500 mr-2" />
        {formatVisitFee(service)}
      </p>
      {service.available_days?.length > 0 && (
        <p className="fs--1 text-700 mb-0">
          <FontAwesomeIcon icon={faCalendarAlt} className="text-500 mr-2" />
          {formatAvailability(service.available_days, service.available_from, service.available_to)}
        </p>
      )}
      {provider && (
        <Media className="align-items-center border-top mt-3 pt-3">
          <Avatar src={provider.photoUrl} name={provider.name} size="l" rounded={provider.isCompany ? 'soft' : 'circle'} className="mr-2" />
          <Media body className="fs--1 font-weight-semi-bold text-truncate">
            {provider.name}
            {provider.verified && <FontAwesomeIcon icon={faCertificate} className="text-primary ml-1" title="Sello Homelan" />}
          </Media>
        </Media>
      )}
    </CardBody>
  </Card>
)

export default ServicePreviewCard
